/**
 * Formats a duration from seconds to hh:mm:ss format
 * @param seconds - The duration in seconds (number)
 * @returns A formatted string in hh:mm:ss format (e.g., "01:23:45")
 *
 */
export const formatDuration = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};
